import {
  maxLength10,
  maxLength6,
  maxLength4,
  required,
  noDigits,
  number,
  trimError,
  onlyLettersAndHyphen,
  noHyphenStartOrEnd,
  onlyDigits,
  onlyLettersAndNumberAndHyphen,
  maxLength80,
  maxLength50,
  onlyLetters,
  trimNoSpecStartOrEnd,
  onlyHouse,
} from '../utils/validation';
import DTO from './DTO';

class VisitDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'driver_name',
        type: String,
        validators: {},
        labelKey: 'driver_name',
      },
      {
        name: 'driver_id',
        type: String,
        validators: {},
        labelKey: 'driver_id',
      },
      {
        name: 'trip_cost',
        type: String,
        validators: {},
        labelKey: 'trip_cost',
      },
      {
        name: 'start_point',
        type: String,
        validators: {},
        labelKey: 'start_point',
      },
      {
        name: 'end_point',
        type: String,
        validators: {},
        labelKey: 'end_point',
      },
      {
        name: 'trip_start_point',
        type: String,
        validators: {},
        labelKey: 'start_point',
      },
      {
        name: 'trip_end_point',
        type: String,
        validators: {},
        labelKey: 'end_point',
      },
      {
        name: 'trip_intermediate_points',
        type: String,
        validators: {},
        labelKey: 'trip_intermediate_points',
      },
      {
        name: 'registry_presence',
        type: String,
        validators: {},
        labelKey: 'registry_presence',
      },
      {
        name: 'carrier',
        type: String,
        validators: {},
        labelKey: 'carrier',
      },
      {
        name: 'registry_presence',
        type: String,
        validators: {},
        labelKey: 'registry_presence',
      },
      {
        name: 'grn_ts',
        type: String,
        validators: {},
        labelKey: 'grn_ts',
      },
      {
        name: 'vehicle_lpn',
        type: String,
        validators: {},
        labelKey: 'grn_ts',
      },
      {
        name: 'trip_started_at',
        type: String,
        validators: {},
        labelKey: 'trip_started_at',
      },
      {
        name: 'trip_ended_at',
        type: String,
        validators: {},
        labelKey: 'trip_ended_at',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default VisitDTO;
